import { render } from "./FooterPart.vue?vue&type=template&id=a4301bdc&ts=true"
import script from "./FooterPart.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterPart.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/FooterPart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4301bdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4301bdc', __exports__)) {
    api.reload('a4301bdc', __exports__)
  }
  
  module.hot.accept("./FooterPart.vue?vue&type=template&id=a4301bdc&ts=true", () => {
    api.rerender('a4301bdc', render)
  })

}


export default __exports__